import { useMemo } from 'react';
import { useReportContext } from './report.context';
import { getScalingUnit, ScalingUnit } from './report.model';

export const useGetScalingSize = () => {
  const scalingUnit = getScalingUnit(useReportContext().scalingStrategy);
  return useMemo(() => getScalingSizeFn(scalingUnit), [scalingUnit]);
};

export const getScalingSizeFn =
  (unit: ScalingUnit) =>
  (...sizes: number[]): string => {
    return sizes.map((size) => `${size}${unit}`).join(' ');
  };
